import React, {InputHTMLAttributes} from 'react'
import {FieldValues, FieldErrors} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'
import {KTText} from '../KTText'
import {KTSVG} from '../KTSVG'

interface Props
 extends InputHTMLAttributes<HTMLSelectElement> {
 label?: string
 id?: string
 name: string
 className?: string
 wrapperClassName?: string
 labelClassName?: string
 isMultiselect?: boolean
 register?: FieldValues
 errors?: FieldErrors | undefined
 data: FieldValues
 value?: string | number | undefined
 OptionValueKey: string | number
 OptionLabelKey: string
 errorIconClassName?: string
 inputWrapperClassName?: string
 iconPath?: string
 showIcon?: boolean
 helperTextClass?: string
 helperText?: string
}

const DropdownField = ({
 label,
 className,
 wrapperClassName,
 labelClassName,
 name,
 value,
 disabled,
 required,
 data,
 id,
 register,
 isMultiselect,
 errorIconClassName,
 inputWrapperClassName,
 helperText,
 placeholder,
 OptionLabelKey,
 OptionValueKey,
 helperTextClass,
 showIcon,
 iconPath,
 errors,
 onChange,
}: Props) => {
 return (
  <div className={`${wrapperClassName}`}>
   <div
    className={`${inputWrapperClassName} ${
     disabled && '!bg-[#F5F8FA]'
    } form-field-wrapper py-2 px-4 relative rounded-lg border border-solid border-[#E6EBF0] bg-white focus-within:border-[#000000]`}
   >
    {label && (
     <label
      htmlFor={id}
      className={`input-label ${labelClassName} relative pb-1 text-[#4E83E4] text-xs font-medium`}
     >
      {label}
      {required && (
       <span className='required-field pl-[2px]'>*</span>
      )}
     </label>
    )}
    <select
     name={name}
     id={id ?? name}
     value={value}
     onChange={onChange}
     className={`form-input ${className} ${
      errors?.[name] && 'border-[#CC293F]'
     }`}
     {...register}
    >
     {!isMultiselect && (
      <option className={''} value={''}>
       {placeholder}
      </option>
     )}

     {data &&
      data.length > 0 &&
      data.map(
       (
        item: Record<string, string | number>,
        key: number
       ) => (
        <option key={key} value={item[OptionValueKey]}>
         {item[OptionLabelKey]}
        </option>
       )
      )}
    </select>
    {((errors?.[name] && showIcon) ?? iconPath) && (
     <KTSVG
      path={`${iconPath ?? '/media/icons/icon_error.svg'}`}
      svgClassName={`${errorIconClassName} absolute bottom-[10px] z-11 right-[10px]`}
     />
    )}
   </div>
   {helperText && !errors?.[name] && (
    <KTText className={helperTextClass}>
     {helperText}
    </KTText>
   )}
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </div>
 )
}

export {DropdownField}
